import { connect } from 'react-redux';
import Player from '../components/Player'

function getCardsInHand(pbnCards) {
    var tempString = '';
    var tempString2 = '';
    for(let i = 0; i < 13; i++) {
        tempString = pbnCards[i];
        if(tempString != 'X') {
            tempString2 = tempString2 + tempString;
        }
    }

    return tempString2;
}

function mapStateToPropsNorthPlayer(state, ownProps){
    return {
        spades: getCardsInHand(state.pbnData.northPbnCards[0]),
        hearts: getCardsInHand(state.pbnData.northPbnCards[1]),
        diamonds: getCardsInHand(state.pbnData.northPbnCards[2]),
        clubs: getCardsInHand(state.pbnData.northPbnCards[3]),
        player: state.pbnData.pbnNorthPlayer
    };
}

function mapStateToPropsEastPlayer(state, ownProps){
    return {
        spades: getCardsInHand(state.pbnData.eastPbnCards[0]),
        hearts: getCardsInHand(state.pbnData.eastPbnCards[1]),
        diamonds: getCardsInHand(state.pbnData.eastPbnCards[2]),
        clubs: getCardsInHand(state.pbnData.eastPbnCards[3]),
        player: state.pbnData.pbnEastPlayer
    };
}

function mapStateToPropsSouthPlayer(state, ownProps){
    return {
        spades: getCardsInHand(state.pbnData.southPbnCards[0]),
        hearts: getCardsInHand(state.pbnData.southPbnCards[1]),
        diamonds: getCardsInHand(state.pbnData.southPbnCards[2]),
        clubs: getCardsInHand(state.pbnData.southPbnCards[3]),
        player: state.pbnData.pbnSouthPlayer
    };
}

function mapStateToPropsWestPlayer(state, ownProps){
    return {
        spades: getCardsInHand(state.pbnData.westPbnCards[0]),
        hearts: getCardsInHand(state.pbnData.westPbnCards[1]),
        diamonds: getCardsInHand(state.pbnData.westPbnCards[2]),
        clubs: getCardsInHand(state.pbnData.westPbnCards[3]),
        player: state.pbnData.pbnWestPlayer
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
    };
}

export const PlayerNorthComp = connect(
    mapStateToPropsNorthPlayer,
    mapDispatchToProps
)(Player);

export const PlayerEastComp = connect(
    mapStateToPropsEastPlayer,
    mapDispatchToProps
)(Player);

export const PlayerSouthComp = connect(
    mapStateToPropsSouthPlayer,
    mapDispatchToProps
)(Player);

export const PlayerWestComp = connect(
    mapStateToPropsWestPlayer,
    mapDispatchToProps
)(Player);